import React, { PropTypes,  Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as toursActions from '../actions/tours';
import { browserHistory } from 'react-router';
import ReactDOM from 'react-dom';
import { icons, positions } from './icons';
import TourRoute from './map/TourRoute';
import TourMarker from './map/TourMarker';
import TourRouteMarker from './map/TourRouteMarker';
import TourStartMarker from './map/TourStartMarker';
import ContactsMarker from './map/ContactsMarker';
import PhotoMarker from './map/PhotoMarker';
import LandmarkMarker from './map/LandmarkMarker';
import LandmarkCluster from './map/LandmarkCluster';
import ToursCluster from './map/ToursCluster';
import Switch  from '../components/map/Switch';
import GoogleMap from 'google-map-react';
import supercluster from 'points-cluster';
import Select from 'react-select';
import Translate from './layout/Translate';
import ClickOutside from 'react-click-outside';
import moment from 'moment';


export default class Map extends Component {
    shoulComponentUpdate() {
        return false;
    }

    componentWillMount() {
        this.boundedObjects = {
            tours: {list: []},
            landmarks: {list: [], count: 3},
            photos: {list: [], count: 5}
        };




        this.activities = [];
        let activities = this.activities;
        this.props.activities.forEach(function(activity){
            activities.push(activity);
        });
        this.activities.unshift({title: <Translate slug="filter__all-activities" />});


        this.destinations = [];
        let destinations = this.destinations;
        this.props.destinations.forEach(function(destination){
            destinations.push(destination);
        });
        this.destinations.unshift({title: <Translate slug="filter__all-destinations" />});

        this.types = [];
        let types = this.types;
        this.props.types.forEach(function(type){
            types.push(type);
        });
        this.types.unshift({title: <Translate slug="filter__all-tours" />});

        //this.seasons = [{title: <Translate slug="filter__all-seasons" />}, {id: 1, title: <Translate slug="filter__winter" />, months: '12,1,2,3'}, {id: 2, title: <Translate slug="filter__spring" />, months: '3,4,5'}, {id: 3, title: <Translate slug="filter__summer" />, months: '6,7,8'}, {id: 4, title: <Translate slug="filter__autumn" />, months: '9,10,11'}];


        this.seasons = [];

        moment.locale(this.props.lang);
        for (let number = 1; number <= 12; number++) {

            this.seasons[number] = {id: number, title: moment(new Date('2017', number-1, '1')).format('MMMM'), months: number};

            //console.log(this.monthList[number]);
        }
        this.seasons.unshift({title: <Translate slug="filter__all-seasons" />});


        this.styles = [
            {"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},
            {"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},
            {"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
            {"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},
            {"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},
            {"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#42414a"}]},
            {"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"off"}]},
            {"featureType": "poi.park", "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},
            {"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},
            {"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},
            {"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},
            {"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},
            {"featureType":"water","elementType":"geometry","stylers":[{"color":"#2e2e39"}]}
        ];

    }

    componentDidMount() {

        this.props.toursActions.fetchPoints(2);
        this.active = true;


        /*
        this.markers = [];
        this.route = {polylines: [], markers: []};

        //console.info(1213123123);
        //console.info(this.props.map.center);

        this.gMap = new google.maps.Map( ReactDOM.findDOMNode(this.refs.map) , {
            center: this.props.map.center,
            zoom: this.props.map.zoom,


        });

        //console.log(this.gMap);
        this.props.toursActions.setMap(this.gMap);

        */
    }


    toggleMapFilter() {
        this.props.toursActions.toggleMapFilter();
    }

    closeMapFilter() {
        if (this.props.showMapFilter) {
            this.props.toursActions.toggleMapFilter();
        }
    }


    onCenterButtonClick() {
        this.props.toursActions.setMapConfig({center: {lat: 44, lng: 111}});
        //console.log({lat: 22, lng: 33})
    }

    componentWillUpdate() {
        if (this.gMap) {
            let map = this.gMap;
            let maps = this.maps;



          //  this.props.toursActions.setBoundedObjects(this.setBoundedObjects());



            let zoom = this.props.map.zoom;


            let actions = this.props.toursActions;

            let photos = '';






        }
    }
            componentDidUpdate() {

                //console.log('update');
                let actions = this.props.toursActions,
                    zoom = this.props.map.zoom,
                    mapComponent = this;
                if (this.gMap) {
                    let map = this.gMap;


                }


                //console.info('LOCATIONSSSSSS');
                //console.info(this.props.locations);
                let props = this.props;
                if (this.maps && this.gMap) {
                    let gMap = this.gMap;
                    let maps = this.maps;
                props.locations.forEach(function(location){


                    let bounds = new maps.LatLngBounds(
                        new maps.LatLng(location.latitude_n, location.longitude_w),
                        new maps.LatLng(location.latitude_s, location.longitude_e)
                    );
                    //console.info(bounds.intersects(gMap.getBounds()));
                    if (bounds.intersects(gMap.getBounds()) && !location.active) {
                        location.active = true;

                        //console.log(location);
                        props.toursActions.setLocation(location);
                        //console.info('LOCATIONSSSSSS');
                        //console.info(location.id);

                    }

                    //console.info('LOCATIONSSSSSS');
                    //console.info(location.id);
                    //console.info(location.active);
                    //console.info(!props.points.isFetching && location.active);

                    if (!props.points.isFetching && location.active)
                    {
                      if (props.points.status[location.id] &&
                          props.points.status[location.id].page &&
                          (props.points.status[location.id].page < props.points.status[location.id].page_count))
                        {
                            //console.info(props.points.status[location.id]);
                            props.toursActions.fetchPointsIfNeeded(location.id, props.points.status[location.id].page + 1);
                        } else {

                          if (!props.points.status[location.id]) {
                              props.toursActions.fetchPointsIfNeeded(location.id);
                          }
                      }
                    }
                });
                }


                if (this.gMap) {
                }
    }

    setBoundedObjects() {
        /*
         let boundedPhotos = [];
         let boundedTours = [];
         let boundedLandmarks = [];
         let photoArray = [];

         let type = this.props.type;
         if (this.props.points.list && this.props.points.list.length && this.props.map.showBoundedObjects) {

         let mapObject = this.gMap;

         this.props.points.list.forEach(function (point, i) {
         point.images.forEach(function (photo) {
         photoArray.push({
         ...photo,
         point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}
         });

         if (mapObject.getBounds().contains({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)})) {
         photo.point = {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)};
         boundedPhotos.push(photo);
         }
         });

         point.tours.forEach(function (tour) {
         //tour.hidden = false;
         photoArray.push({
         ...tour,
         point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}
         });

         if (mapObject.getBounds().contains({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)})) {
         //    if (type.id && type.id != tour.type) {
         //        tour.hidden = true;
         //    }

         boundedTours.push(tour);
         }
         });



         point.landmarks.forEach(function (landmark) {
         photoArray.push({
         ...landmark,
         point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}
         });

         if (mapObject.getBounds().contains({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}) && landmark.title) {
         boundedLandmarks.push(landmark);
         }
         });
         });


         this.boundedObjects = {
         photos: {list: boundedPhotos, count: 5},
         tours: {list: boundedTours},
         landmarks: {list: boundedLandmarks, count: 3}

         };

         }

         return {
         photos: {list: boundedPhotos, count: 5},
         tours: {list: boundedTours},
         landmarks: {list: boundedLandmarks, count: 3}

         };
         */
    }

    setBoundedPhoto() {
         let boundedPhotos = [];
         let boundedTours = [];
         let boundedLandmarks = [];
         let photoArray = [];

         if (this.props.points.list && this.props.points.list.length && this.props.map.showBoundedObjects) {

         let mapObject = this.gMap;

         this.props.points.list.forEach(function (point, i) {
         point.images.forEach(function (photo) {
         photoArray.push({
         ...photo,
         point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}
         });

         if (mapObject.getBounds().contains({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)})) {
         photo.point = {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)};
         boundedPhotos.push(photo);
         }
         });
;


         });


         this.boundedObjects = {
         photos: {list: boundedPhotos, count: 5},
         tours: {list: boundedTours},
         landmarks: {list: boundedLandmarks, count: 3}

         };

         }

         return {
         photos: {list: boundedPhotos, count: 5},
         tours: {list: boundedTours},
         landmarks: {list: boundedLandmarks, count: 3}

         };
    }

    boundsChange(map){

            this.props.toursActions.setMapConfig({center: map.center, zoom: map.zoom});
            //console.log(1111111)
            //console.log(this.props.map.active)
            if (this.props.map.active) {
                browserHistory.replace('/map?lat='+map.center.lat+'&lng='+map.center.lng+'&zoom='+map.zoom);
            }

        if (this.props.destination.id && this.props.destination.point) {
            let filter = Object.assign({}, this.props.filter);
            let destination = this.props.destination;
            let actions = this.props.toursActions;

            let mapConfig = this.props.map;
            setTimeout(function(){

                if (mapConfig.active && map.center.lat != destination.point.latitude) {
                    actions.selectDestination({});
                    delete filter.d;
                    actions.toursSearch(filter);
                }
            }, 1000);
        }
        //console.log('!!!!!')
        //console.log(browserHistory)

        //console.log('BOUNDED UPDATE');


    }

    setConfig(config) {
        this.props.toursActions.setMapConfig(config);
    }

    setConfigByInput(key, value, e) {
        //console.log(e)
        let config = {};
        config[key] = !value;
        this.props.toursActions.setMapConfig(config);
    }


    componentWillUnmount() {

        this.setBoundedObjects();

    }

    latLng2Point(latLng, map) {
        var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = map.getProjection().fromLatLngToPoint(new google.maps.LatLng(latLng));
        return [(worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale];
    }

    setMap(map, maps){
        //console.log('!!!!!!!!!!!');
        //console.log(map, maps)
        this.gMap = map;
        this.maps = maps;
        let obj = this;
            map.addListener('dragend', function(){
                obj.boundsChange({center: {lat: map.center.lat(), lng: map.center.lng()}, zoom: map.zoom});
            });





        setTimeout(reinitMap, 100);

        let actions = this.props.toursActions;
        function reinitMap() {
            actions.setMapConfig({center: {lat: map.center.lat(), lng: map.center.lng()}, zoom: map.zoom});

        }
    }


    setZoom(map) {
        let obj = this,
            zoom = this.props.map.zoom;

        setTimeout(function(){
            if (zoom != map.zoom) {
                obj.boundsChange(map);
            }
        }, 200);
    }


    setListMode() {
        if (!this.props.map.active) {
            this.props.toursActions.setMapConfig({listByMap: false});
        }
    }

    selectDestination (destination, toggle, e) {
        this.props.toursActions.selectDestination(destination);
        this.props.toursActions.toursSearch(Object.assign(this.props.filter, {d: destination.id}));
        if (this.props.map.destination) {
            if (destination.id) {
                browserHistory.push('/destinations/' + destination.slug);
            } else {
                browserHistory.push('/tours');
            }
        }
        this.setListMode();
        if (toggle) {
            this.props.toursActions.toggleMapFilter();
        }



        if (!this.props.map.active) {
            if (this.props.filter.t || this.props.filter.m || this.props.filter.d || this.props.filter.s) {
                browserHistory.replace('/tours?' +
                    this.encodeQueryData({
                        type: this.props.type.id,
                        destination: destination.id,
                        season: this.props.season.id,
                        activity: this.props.activity.id
                    })
                )
            } else {
                browserHistory.replace('/tours');
            }
        }

    }

    selectType (type, toggle, e) {

        console.log('type');
        console.log(type);

        this.props.toursActions.selectType(type);
        this.setBoundedObjects();
        this.props.toursActions.toursSearch(Object.assign(this.props.filter, {t: type.id}));

        this.setListMode();
        if (toggle) {
            this.props.toursActions.toggleMapFilter();
        }




        if (!this.props.map.active) {
            if (type.id || this.props.filter.m || this.props.filter.d || this.props.filter.s) {
                browserHistory.replace('/tours?' +
                    this.encodeQueryData({
                        type: type.id,
                        destination: this.props.destination.id,
                        season: this.props.season.id,
                        activity: this.props.activity.id
                    })
                )
            } else {
                browserHistory.replace('/tours');
            }
        }

    }

    selectSeason (season, toggle, e) {
        this.props.toursActions.selectSeason(season);


        this.props.toursActions.toursSearch(Object.assign(this.props.filter, {m: season.months}));

        this.setListMode();
        if (toggle) {
            this.props.toursActions.toggleMapFilter();
        }






        if (!this.props.map.active) {
            if (this.props.filter.t || this.props.filter.m || this.props.filter.d || season.id) {
                browserHistory.replace('/tours?' +
                    this.encodeQueryData({
                        type: this.props.type.id,
                        destination: this.props.destination.id,
                        season: season.id,
                        activity: this.props.activity.id
                    })
                )
            } else {
                browserHistory.replace('/tours');
            }
        }

    }

    selectActivity (activity, toggle, e) {
        this.props.toursActions.selectActivity(activity);
        this.setBoundedObjects();
        this.props.toursActions.toursSearch(Object.assign(this.props.filter, {a: activity.id}));
        this.setListMode();
        if (toggle) {
            this.props.toursActions.toggleMapFilter();
        }


        if (!this.props.map.active) {
            if (this.props.filter.t || this.props.filter.m || this.props.filter.d || activity.id) {
                browserHistory.replace('/tours?' +
                    this.encodeQueryData({
                        type: this.props.type.id,
                        destination: this.props.destination.id,
                        season: this.props.season.id,
                        activity: activity.id
                    })
                )
            } else {
                browserHistory.replace('/tours');
            }
        }


    }

    encodeQueryData(data) {
        let ret = [];
        for (let d in data){
            if (data[d]) {
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            }
        }
        return ret.join('&');
    }

    updateMap() {

        google.maps.event.trigger(this.gMap, "resize");
        //console.info('height:', this.props.mapHeight);
    }

    _onChildMouseEnter (key /*, childProps */) {
        this.hoverKey = key;
    }

    _onChildMouseLeave  () {
        this.hoverKey = null;
    }



    render () {



        let tourIcons = '',
            map = this.gMap,
            maps = this.maps,
            actions = this.props.toursActions,
            zoom = 7;

        let photos = '';

        let landmarks = '';
        let tours = '';


        if (this.gMap) {
            zoom = map.getZoom();
            this.gMap.addListener('zoom_changed', function() {
                zoom = map.getZoom();
            });


        if (this.props.map.route && this.props.map.route.markers && ((this.props.map.active && this.props.map.show_tours) || this.props.map.activeRoute) ) {
        tourIcons = this.props.map.route.markers
            .map((icon, i) => {
               let coords = {lat: parseFloat(icon.coords.latitude), lng: parseFloat(icon.coords.longitude)};
                if (icon.type != 'start') {
                    return (
                        <TourRouteMarker
                            key={'marker' + i}
                            {...coords}
                            text={icon.type}
                            zoom={zoom}
                            map_config={this.props.tour.map_config}
                            map={map}
                            scroll={this.props.scroll}
                            maps={maps}
                            actions={this.props.toursActions}
                            options={icon.options}
                            // use your hover state (from store, react-controllables etc...)
                            hover={this.hoverKey === i} />
                    );
                }
            });
        }
/*
            landmarks = landmarkArray
                .map((icon, i) => {

                    let coords = icon.point;

                    return (
                        <LandmarkMarker
                            key={i}
                            {...coords}
                            point={coords}
                            map={map}
                            maps={maps}
                            landmark={icon}
                            actions={actions}
                            // use your hover state (from store, react-controllables etc...)
                            hover={this.hoverKey === i} />
                    );
                });
*/
            let landmarkClusters = [],
                toursClusters = [];

            if (this.props.map.active) {



                let photoArray = [];
                let landmarkArray = [];
                let toursArray = [];
                if (this.props.points.list && this.props.points.list.length) {



                    /*
                     this.props.points.list.forEach(function(point, i) {
                     point.images.forEach(function(photo){
                     photoArray.push({...photo, point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}});
                     })
                     });
                     */

                    this.props.points.list.forEach(function(point, i) {
                        point.images.forEach(function(photo){
                            photoArray.push({...photo, lat: parseFloat(point.latitude), lng: parseFloat(point.longitude), point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}});
                        })
                    });

                    this.props.points.list.forEach(function(point, i) {
                        point.landmarks.forEach(function(landmark){
                            if (landmark.title) {
                                landmarkArray.push({...landmark, lat: parseFloat(point.latitude), lng: parseFloat(point.longitude), point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}});
                            }
                        })
                    });

                    this.props.points.list.forEach(function(point, i) {
                        point.tours.forEach(function(tour){
                            toursArray.push({...tour, lat: parseFloat(point.latitude), lng: parseFloat(point.longitude), point: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)}});
                        })
                    });
                }


                if (this.props.map.show_photos) {
                    photos = photoArray
                        .map((icon, i) => {

                            let coords = icon.point;



                            //  this.props.toursActions.setBoundedObjects(this.setBoundedObjects());
                            if (map.getBounds().contains({lat: parseFloat(icon.point.lat), lng: parseFloat(icon.point.lng)})) {

                            if (icon.quality == 3 ||
                                icon.quality == 2 && zoom >= 6 ||
                                icon.quality == 1 && zoom >= 11 ||
                                zoom > 12
                            ) {
                                return (

                                    <PhotoMarker
                                        onClick={this.setBoundedPhoto.bind(this)}
                                        key={'photo' + i}
                                        index={i}
                                        {...coords}
                                        point={coords}
                                        points={this.props.points}
                                        map={map}
                                        zoom={zoom}
                                        photo={icon}
                                        actions={actions}
                                        // use your hover state (from store, react-controllables etc...)
                                        hover={this.hoverKey === i} />
                                );
                            }

                            }
                        });
                }


                let bounds = map.getBounds();

            if (landmarkArray.length) {

                var index = supercluster(landmarkArray, {
                    radius: 150,
                    maxZoom: 13
                });

                landmarkClusters = index({
                    bounds: {
                        nw: { lat: bounds.getNorthEast().lat(), lng: bounds.getSouthWest().lng() },
                        se: { lat: bounds.getSouthWest().lat(), lng: bounds.getNorthEast().lng() } },
                    zoom: zoom
                });
            }

            if (toursArray.length) {
                //console.info(toursArray);

                var index = supercluster(toursArray, {
                    radius: 50,
                    maxZoom: 13
                });

                toursClusters = index({
                    bounds: {
                        nw: { lat: bounds.getNorthEast().lat(), lng: bounds.getSouthWest().lng() },
                        se: { lat: bounds.getSouthWest().lat(), lng: bounds.getNorthEast().lng() } },
                    zoom: zoom
                });
            }

                if (this.props.map.show_landmarks) {
                    landmarks = landmarkClusters
                        .map((cluster, i) => {
                            if (cluster.points.length > 1) {
                                return (
                                    <LandmarkCluster
                                        key={'landmarkCluster' + i}
                                        lat={cluster.y}
                                        lng={cluster.x}
                                        count={cluster.points.length}
                                        map={map}
                                        maps={maps}
                                        zoom={zoom}
                                        landmarks={cluster.points}
                                        actions={actions}/>
                                );
                            } else {

                                let icon = cluster.points[0],
                                    coords = icon.point;

                                return (
                                    <LandmarkMarker
                                        key={icon.id}
                                        {...coords}
                                        point={coords}
                                        map={map}
                                        maps={maps}
                                        landmark={icon}
                                        actions={actions}
                                        // use your hover state (from store, react-controllables etc...)
                                        hover={this.hoverKey === i}/>
                                );
                            }
                        });
                }

                if (this.props.map.show_tours) {
                    tours = toursClusters
                        .map((cluster, i) => {
                            if (cluster.points.length > 1) {
                                return (
                                    <ToursCluster
                                        key={'toursCluster' + i}
                                        lat={cluster.y}
                                        lng={cluster.x}
                                        count={cluster.points.length}
                                        map={map}
                                        maps={maps}
                                        zoom={zoom}
                                        tours={cluster.points}
                                        actions={actions}/>
                                );
                            } else {

                                let icon = cluster.points[0],
                                    coords = icon.point;
                                if (icon.id != this.props.tour.id) {
                                    return (
                                        <TourMarker
                                            key={'tour' + icon.id}
                                            {...coords}
                                            point={coords}
                                            map={map}
                                            maps={maps}
                                            tour={icon}
                                            actions={actions}
                                        />
                                    );
                                }
                            }
                        });
                }
            }



            this.maps.event.trigger(this.gMap, "resize");
            this.maps.event.trigger(this.gMap, "zoom_changed");
        }

        let startRoutePoint = false;
        if (this.props.map.route && this.props.map.route.polylines) {
            this.props.map.route.polylines.forEach(function(polyline){
                if (!startRoutePoint && polyline.path[0]) {
                    startRoutePoint = polyline.path[0];
                    if (!startRoutePoint.latitude) {
                        startRoutePoint.latitude = parseFloat(startRoutePoint[1]);
                        startRoutePoint.longitude = parseFloat(startRoutePoint[0]);
                    }
                }
            });
            //console.log('startRoutePoint');
            //console.log(startRoutePoint);
        }

        return (
            <div className={"map "} style={{opacity: this.props.scroll.opacity, visibility: (this.props.scroll.opacity == 0)?'hidden':'visible'}}>
            <div className={"section__map " + ((!this.props.map.active && !this.props.map.contacts)?"map__inactive":"")}  style={{width: this.props.map.width, 'height': '100%'}}>
                {this.active &&
                <GoogleMap yesIWantToUseGoogleMapApiInternals={true} onGoogleApiLoaded={({map, maps}) => this.setMap(map, maps)}
                   center={{lat: parseFloat(this.props.map.center.lat), lng: parseFloat(this.props.map.center.lng)}}
                   zoom={parseInt(this.props.map.zoom)}
                   options={{styles: this.styles, mapTypeId: (maps && maps.MapTypeId)?(maps.MapTypeId[this.props.map.type]):'', zoomControl: false}}
                   bootstrapURLKeys={{
                        key: 'AIzaSyCP4RGkfA8JNMkpbqanQnpZ2384hshV6rI'
                    }}
                   onChange={this.setZoom.bind(this)}
                   debounced={false}
                >
                    {landmarks}
                    {photos}
                    {tourIcons}
                    {tours}
                    {(this.props.map.route && this.props.map.route.markers) && (((this.props.map.active) && this.props.map.show_tours)  || this.props.map.activeRoute) && this.props.map.route.polylines.length &&
                        <TourStartMarker
                            scroll={this.props.scroll}
                            activeRoute={this.props.map.activeRoute}
                            lat={(startRoutePoint.latitude)?startRoutePoint.latitude:0}
                            lng={(startRoutePoint.longitude)?startRoutePoint.longitude:0}
                            tour={this.props.tour} route={this.props.map.route}
                            actions={this.props.toursActions}
                        >

                        </TourStartMarker>
                    }
                    {this.props.map.contacts &&
                        <ContactsMarker
                            lat={52.280157}
                            lng={104.317879}
                            content={
                                <div>
                                    <div className="map__contact_title"><Translate slug="contacts__irkutsk__title" /></div>
                                    <p className="map__contact_text"><Translate slug="contacts__irkutsk__schedule" /></p>
                                    <p className="map__contact_text"><Translate slug="contacts__irkutsk__address" /></p>
                                    <p className="map__contact_text"><Translate slug="contacts__irkutsk__phone" /></p>
                                </div>
                            }
                            actions={this.props.toursActions}
                        />
                    }
                    {this.props.map.contacts &&
                        <ContactsMarker
                            lat={59.935885}
                            lng={30.324034}
                            content={
                                <div>
                                    <div className="map__contact_title"><Translate slug="contacts__sp__title" /></div>
                                    <p className="map__contact_text"><Translate slug="contacts__sp__schedule" /></p>
                                    <p className="map__contact_text"><Translate slug="contacts__sp__address" /></p>
                                    <p className="map__contact_text"><Translate slug="contacts__sp__phone" /></p>


                                </div>
                            }
                            actions={this.props.toursActions}
                        />
                    }
                </GoogleMap>
                }
                {(this.props.tour.loaded && this.gMap) && ((this.props.map.active && this.props.map.show_tours) || this.props.map.activeRoute) &&
                <TourRoute scroll={this.props.scroll} tour={this.props.tour} gMap={this.gMap} route={this.props.map.route}></TourRoute>
                }


            </div>
                {(this.props.map.active || this.props.map.showBoundedObjects) && !this.props.map.boundedObjectsWithoutFilters &&
                <div>
                    <div className="map__header">
                    <div className="form map__filters">

                        <div className={"map__filter filter " + ((this.props.showMapFilter)?"filter_active":"")}>
                            <ClickOutside onClickOutside={this.closeMapFilter.bind(this)}>
                                <div className="filter__select">
                                    <div onClick={this.toggleMapFilter.bind(this)} className={
                                            "filter__title  " +
                                            ((this.props.type.id)?" filter__title_selected":"") +
                                            ((this.props.showMapFilter)?" filter__title_active":"")
                                            }>
                                        {(this.props.type.id)?this.props.type.title:<Translate slug="filter__all-tours" />}
                                    </div>
                                    <div className="filter__list">
                                        {this.types.map((type, i)=>
                                            <div onClick={this.selectType.bind(this, type, true)} className={"filter__item " + ((type.id == this.props.type.id)?"filter__item_active":"")}>{type.title}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="filter__select">
                                    <div onClick={this.toggleMapFilter.bind(this)} className={
                                            "filter__title  " +
                                            ((this.props.destination.id)?" filter__title_selected":"") +
                                            ((this.props.showMapFilter)?" filter__title_active":"")
                                            }>
                                        {(this.props.destination.id)?this.props.destination.title:<Translate slug="filter__all-destinations" />}
                                    </div>

                                    <div className="filter__list">
                                        {this.destinations.map((destination, i)=>
                                            <div onClick={this.selectDestination.bind(this, destination, true)} className={"filter__item " + ((destination.id == this.props.destination.id)?"filter__item_active":"")}>{destination.title}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="filter__select">
                                    <div onClick={this.toggleMapFilter.bind(this)} className={
                                            "filter__title  " +
                                            ((this.props.activity.id)?" filter__title_selected":"") +
                                            ((this.props.showMapFilter)?" filter__title_active":"")
                                            }>
                                        {(this.props.activity.id)?this.props.activity.title:<Translate slug="filter__all-activities" />}
                                    </div>
                                    <div className="filter__list">
                                        {this.activities.map((activity, i)=>
                                            <div onClick={this.selectActivity.bind(this, activity, true)} className={"filter__item " + ((activity.id == this.props.activity.id)?"filter__item_active":"")}>{activity.title}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="filter__select">
                                    <div onClick={this.toggleMapFilter.bind(this)} className={
                                            "filter__title  " +
                                            ((this.props.season.id)?" filter__title_selected":"") +
                                            ((this.props.showMapFilter)?" filter__title_active":"")
                                            }>
                                        {(this.props.season.id)?this.props.season.title:<Translate slug="filter__all-seasons" />}
                                    </div>
                                    <div className="filter__list">
                                        {this.seasons.map((season, i)=>
                                            <div onClick={this.selectSeason.bind(this, season, true)} className={"filter__item " + ((season.id == this.props.season.id)?"filter__item_active":"")}>{season.title}</div>
                                        )}
                                    </div>
                                </div>


                                <div className="filter__selects">
                                    <button className="filter__button" onClick={this.toggleMapFilter.bind(this)}>
                                        <Translate slug="map__filters"/>
                                    </button>
                                    <div className="filter__close" onClick={this.toggleMapFilter.bind(this)}></div>
                                    <div>



                                        <Select
                                            className="form__select"
                                            name="form-field-name"
                                            placeholder={this.props.translations['filter__all-tours']}
                                            value={this.props.type.id}
                                            options={this.types}
                                            labelKey="title"
                                            valueKey="id"
                                            clearable={false}
                                            searchable={false}
                                            onChange={this.selectType.bind(this)}
                                        />
                                        <Select
                                            className="form__select"
                                            name="form-field-name"
                                            placeholder={this.props.translations['filter__all-destinations']}
                                            value={this.props.destination.id}
                                            options={this.destinations}
                                            labelKey="title"
                                            valueKey="id"
                                            clearable={false}
                                            searchable={false}
                                            onChange={this.selectDestination.bind(this)}
                                        />
                                        <Select
                                            className="form__select"
                                            name="form-field-name"
                                            placeholder={this.props.translations['filter__all-activities']}
                                            value={this.props.activity.id}
                                            options={this.activities}
                                            labelKey="title"
                                            valueKey="id"
                                            clearable={false}
                                            searchable={false}
                                            onChange={this.selectActivity.bind(this)}
                                        />
                                        <Select
                                            className="form__select"
                                            name="form-field-name"
                                            placeholder={this.props.translations['filter__all-seasons']}
                                            value={this.props.season.id}
                                            options={[{title: this.props.translations['filter__all-seasons']}, {id: 1, title: this.props.translations['filter__winter'], months: '12,1,2,3'}, {id: 2, title: this.props.translations['filter__spring'], months: '3,4,5'}, {id: 3, title: this.props.translations['filter__summer'], months: '6,7,8'}, {id: 4, title: this.props.translations['filter__autumn'], months: '9,10,11'}]}
                                            labelKey="title"
                                            valueKey="id"
                                            clearable={false}
                                            searchable={false}
                                            onChange={this.selectSeason.bind(this)}



                                    />
                                        <button className="filter__complete" onClick={this.toggleMapFilter.bind(this)}><Translate slug="map__filters__apply"/></button>
                                    </div>

                                </div>

                            </ClickOutside>
                        </div>


                        {false &&
                            <Switch active={this.props.map.active} boundedObjects={this.boundedObjects} actions={this.props.toursActions} setMapConfig={this.props.toursActions.setMapConfig} translations={this.props.translations}></Switch>
                        }
                    </div>
                    </div>
                    {this.props.map.active &&
                        <div className={"map__controls " + (!this.props.map.active?"map__inactive":"")}>

                            <div>
                                <button className="map__zoom map__zoom_in"
                                        onClick={this.setConfig.bind(this, {zoom: zoom+1})}></button>
                            </div>
                            <div>
                                <button className="map__zoom map__zoom_out"
                                        onClick={this.setConfig.bind(this, {zoom: zoom-1})}></button>
                            </div>
                            <div className="map__checkboxes">
                                <div>
                                    <label className="map__checkbox">
                                        <input className="checkbox" type="checkbox" checked={this.props.map.show_photos}
                                               onChange={this.setConfigByInput.bind(this, 'show_photos', this.props.map.show_photos)}/>
                                        <span>
                                            <Translate slug="controls__photo"/>
                                        </span>
                                    </label>
                                </div>
                                <div>
                                    <label className="map__checkbox map__checkbox_hidden">
                                        <input className="checkbox" type="checkbox" checked={this.props.map.show_landmarks}
                                               onChange={this.setConfigByInput.bind(this, 'show_landmarks', this.props.map.show_landmarks)}/>
                                        <span>
                                            <Translate slug="controls__info"/>
                                        </span>
                                    </label>
                                </div>
                                <div>
                                    <label className="map__checkbox map__checkbox_hidden">
                                        <input className="checkbox" type="checkbox" checked={this.props.map.show_tours}
                                               onChange={this.setConfigByInput.bind(this, 'show_tours', this.props.map.show_tours)}/>
                                        <span>
                                            <Translate slug="controls__tours"/>
                                        </span>
                                    </label>
                                </div>
                            </div>
                            {this.props.map.type == 'ROADMAP' &&
                            <div>
                                <div className="map__type map__type_satellite"
                                     onClick={this.setConfig.bind(this, {type: 'SATELLITE'})}>
                                    <Translate slug="controls__satellite"/>
                                </div>
                            </div>
                            }
                            {this.props.map.type == 'SATELLITE' &&
                            <div>
                                <div className="map__type map__type_scheme"
                                     onClick={this.setConfig.bind(this, {type: 'ROADMAP'})}>
                                    <Translate slug="controls__scheme"/>
                                </div>
                            </div>
                            }
                        </div>
                    }
                </div>
                }
            </div>
        );
    }
}




function mapStateToProps (state) {
    return {
        tour: state.tours.tour,
        list: state.tours.list,
        map: state.tours.map,
        mapHeight: state.tours.mapHeight,
        points: state.tours.points,
        destination: state.tours.destination,
        types: state.tours.types,
        type: state.tours.type,
        season: state.tours.season,
        destinations: state.tours.destinations,
        activities: state.tours.activities,
        activity: state.tours.activity,
        scroll: state.tours.scroll,
        translations: state.user.translations,
        locations: state.tours.locations,
        landmark: state.tours.landmark,
        filter: state.tours.mapFilterParams,
        showMapFilter: state.tours.showMapFilter,
        lang: state.user.lang
    }
}

function mapDispatchToProps (dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Map)




// WEBPACK FOOTER //
// ./src/common/components/Map.js